import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../icon/Icon.jsx';
import Button from '../../../button/Button.jsx';

const RegionFilter = ({
  formAction,
  geoLocationLabel,
  handleSearchValue,
  searchLabel,
  searchValue,
  radiusLabel,
  radiusDefault,
  radiusOptions,
  className
}) => {
  const [geoLocationSupport, setGeoLocationSupport] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if ('geolocation' in navigator) {
      setGeoLocationSupport(true);
    } else {
      setGeoLocationSupport(false);
    }
  }, []);

  useEffect(() => {
    handleSearchValue((prev) => ({ ...prev, radiusValue: radiusDefault ?? '' }));
  }, [radiusDefault]);

  const handleGeoLocation = (e) => {
    setLoading(true);
    navigator.geolocation.getCurrentPosition(async (position) => {
      try {
        const response = await fetch(formAction, {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          })
        });

        const json = await response.json();

        if (json.state === 'success') {
          setLoading(false);
          handleSearchValue((prev) => ({
            ...prev,
            searchValue: json.searchValue
          }));
        } else if (json.state === 'error') {
          setLoading(false);
        }
      } catch (err) {
        setLoading(false);
      }
    });
  };

  return (
    // Styles from teaser regions filter
    <div className={`regions-filter ${className}`}>
      {geoLocationSupport && (
        <Button
          onClick={(e) => handleGeoLocation(e)}
          label={loading ? 'Loading...' : geoLocationLabel}
          icon="geoLocation"
          iconSize="large"
          labelVariant="copy-label"
          className="regions-filter__geo-button"
          modifiers={['tertiary', 'direction-column']}
        />
      )}

      <div className="regions-filter__search">
        <Icon id="search" className="regions-filter__search-input-icon" />
        <input
          type="input"
          name="location"
          defaultValue={searchValue}
          placeholder={searchLabel}
          onChange={(e) =>
            handleSearchValue((prev) => ({
              ...prev,
              searchValue: e.target.value
            }))
          }
          className="regions-filter__search-input"
        />

        <select
          aria-label={radiusLabel}
          name="radius"
          onChange={(e) =>
            handleSearchValue((prev) => ({
              ...prev,
              radiusValue: e.target.value
            }))
          }
          className="regions-filter__search-select"
        >
          {!radiusOptions.includes(radiusDefault) && <option value="">{radiusDefault}</option>}
          {radiusOptions.map((radius) => radius === radiusDefault ? (
              <option key={radius} value={radius} selected>
                +{radius} KM
              </option>
            ) : (
              <option key={radius} value={radius}>
                +{radius} KM
              </option>
          ))}
        </select>
        <Icon id="angleDown" className="regions-filter__search-select-icon" />
      </div>
    </div>
  );
};

RegionFilter.propTypes = {
  formAction: PropTypes.string.isRequired,
  geoLocationLabel: PropTypes.string.isRequired,
  handleSearchValue: PropTypes.func.isRequired,
  searchLabel: PropTypes.string.isRequired,
  searchValue: PropTypes.string,
  radiusLabel: PropTypes.string.isRequired,
  radiusDefault: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  radiusOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  className: PropTypes.string
};

RegionFilter.defaultProps = {
  searchValue: '',
  className: ''
};

export default RegionFilter;
